import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryApparel';
/** Renders an SVG icon. */
const SvgCategoryApparel = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path d="M14.326 13.438a.75.75 0 0 1 .994 1.123L13.13 16.5l2.19 1.939a.75.75 0 1 1-.994 1.122l-2.823-2.5a.75.75 0 0 1 0-1.123zm3.644 1.032a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06" />
      <path d="m16.604 17.646.793-.792a.5.5 0 0 0 0-.708l-.793-.792a.5.5 0 0 0-.707 0l-.793.792a.5.5 0 0 0 0 .708l.793.792a.5.5 0 0 0 .707 0" />
      <path d="M22 12a1 1 0 0 1 1.707-.707l2.185 2.184 1.788-2.383-3.016-3.016A6 6 0 0 0 21.877 6.5l-1.342-.336-.746 1.494a4.237 4.237 0 0 1-7.578 0l-.747-1.494-1.34.336a6 6 0 0 0-2.788 1.578l-3.017 3.016 1.788 2.383 2.186-2.184A1 1 0 0 1 10 12v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zm-8-5.236a2.236 2.236 0 0 0 4 0L18.382 6h-4.764zM24 25a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V14.414l-1.293 1.293A1 1 0 0 1 5.2 15.6l-3-4a1 1 0 0 1 .093-1.307l3.629-3.629A8 8 0 0 1 9.639 4.56l2.119-.53.12-.022A1 1 0 0 1 12 4h8a1 1 0 0 1 .242.03l2.12.53a8 8 0 0 1 3.716 2.104l3.63 3.629A1 1 0 0 1 29.8 11.6l-3 4a1 1 0 0 1-1.507.107L24 14.414z" />
    </svg>
  );
};
SvgCategoryApparel.displayName = displayName;
export default SvgCategoryApparel;
